<template>
  <div>
    <SalesEarningsGraph
      class="graph"
      heading="DESIGNS.DETAILS.STATISTICS.HEADING"
      subheading="DESIGNS.DETAILS.STATISTICS.SUBHEADING"
      sales-subheading="DESIGNS.DETAILS.STATISTICS.TOTAL_SALES_INFO"
      earnings-subheading="DESIGNS.DETAILS.STATISTICS.TOTAL_EARNINGS_INFO"
      display-pos-aggregate
      display-chart-heading
      :data="ideaStatisticData"
      :initialized="initialized"
      :error="loadError"
      :start-date="idea.dateCreated"
      @on-load-data="fetchStatistics"
      @retry="retry"
    />
    <div
      v-if="initialized && bestsellerData && bestsellerData.length"
      class="bestsellers"
    >
      <div class="bestsellers-heading">
        <h4>{{ $t('STATISTICS.BESTSELLERS.HEADING') }}</h4>
      </div>
      <div class="bestsellers">
        <BestsellerList :data="bestsellerData" />
      </div>
    </div>
  </div>
</template>

<script>
import statisticsService from 'commons/api/statisticsService/statisticsService';
import BestsellerList from 'src/app/partnerarea/statistics/bestseller/BestsellerList.vue';
import SalesEarningsGraph from 'src/app/components/charts/sales/SalesEarningsGraph.vue';

export default {
  name: 'IdeaStatistics',
  components: {
    BestsellerList,
    SalesEarningsGraph,
  },
  props: {
    idea: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      initialized: false,
      loadError: false,
      lastFilters: null,
      bestsellerData: null,
      ideaStatisticData: null,
    };
  },
  computed: {},
  methods: {
    async fetchStatistics(filters) {
      this.initialized = false;
      this.loadError = false;
      this.lastFilters = filters;

      try {
        const data = await statisticsService.getIdeaStatistics(this.idea.id, {
          pos: filters.pos.value,
          dateFrom: filters.time.from,
          dateTo: filters.time.to,
        });
        this.ideaStatisticData = data.timeline ? data : null;

        const bestsellerData = await statisticsService.getBestsellers({
          pos: filters.pos.value,
          dateFrom: filters.time.from,
          dateTo: filters.time.to,
          ideaId: this.idea.id,
          type: 'PTIDEA',
        });
        this.bestsellerData = bestsellerData.list;

        this.initialized = true;
      } catch (error) {
        console.error('idea statistics failed', error);
        this.loadError = true;
      }
    },
    retry() {
      if (this.lastFilters) {
        this.fetchStatistics(this.lastFilters);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/styleguide/type';

.bestsellers-heading {
  background-color: $white;
  padding: 16px 24px;

  h4 {
    margin: 0;
  }
}

.bestsellers {
  :deep(.stat-item:first-child) {
    border-radius: 0;
  }
}

.graph {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
</style>
